/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgUpParent = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m12 5 .999 1H13v.001l4.707 4.706-1.414 1.414L13 8.829V18h-2V8.827l-3.293 3.294-1.414-1.414z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgUpParent as UpParent };
